import { YOO_FINDS_CDN } from "@/common";

const ROOT = `${YOO_FINDS_CDN}/h5/ai`;

export const AI_ICON = `${ROOT}/ai-icon.png`;

export const AI_ICON_GRAY = `${ROOT}/ai-icon-gray.png`;
